import { actionConstants } from 'redux-layer/constants';
import {
  startReqActionType,
  successReqActionType,
  failReqActionType,
  apiHeader
} from 'helper/requestHelper';
import { getEnvironment } from 'helper/utils';
import { NotificationManager } from 'react-notifications';

const agentApiUrl = path => `${getEnvironment().API_URL}v2/agent${path}`;

const parseAgentResponse = async response => {
  let json = null;
  try {
    json = await response.json();
  } catch (error) {
    json = null;
  }

  if (!response.ok) {
    const detail = json?.detail || json?.message;
    let message = 'Request failed';
    if (Array.isArray(detail)) {
      message = detail.map(item => item.msg || item).join(', ');
    } else if (typeof detail === 'string' && detail) {
      message = detail;
    }
    throw new Error(message);
  }

  return json;
};

export const listCustomerSessions = customerId => async dispatch => {
  dispatch({ type: startReqActionType(actionConstants.GET_SESSIONS) });
  const requestOptions = {
    method: 'GET',
    headers: apiHeader()
  };

  try {
    const response = await fetch(
      agentApiUrl(`/${encodeURIComponent(customerId)}/sessions`),
      requestOptions
    );
    const data = await parseAgentResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.GET_SESSIONS),
      payload: {
        customer_id: data.customer_id || customerId,
        sessions: data.sessions || []
      }
    });
  } catch (error) {
    dispatch({
      type: failReqActionType(actionConstants.GET_SESSIONS)
    });
    NotificationManager.error(
      error.message || 'Failed to load sessions',
      'Error',
      3000
    );
  }
};

export const getSessionDetail = sessionId => async dispatch => {
  dispatch({ type: startReqActionType(actionConstants.GET_SESSION) });
  const requestOptions = {
    method: 'GET',
    headers: apiHeader()
  };

  try {
    const response = await fetch(
      agentApiUrl(`/${encodeURIComponent(sessionId)}`),
      requestOptions
    );
    const data = await parseAgentResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.GET_SESSION),
      payload: data
    });
  } catch (error) {
    dispatch({
      type: failReqActionType(actionConstants.GET_SESSION)
    });
    NotificationManager.error(
      error.message || 'Failed to load session',
      'Error',
      3000
    );
  }
};

export const updateSession = (sessionId, updates) => async dispatch => {
  dispatch({ type: startReqActionType(actionConstants.UPDATE_SESSION) });
  const requestOptions = {
    method: 'PUT',
    headers: apiHeader(),
    body: JSON.stringify(updates)
  };

  try {
    const response = await fetch(
      agentApiUrl(`/${encodeURIComponent(sessionId)}`),
      requestOptions
    );
    const data = await parseAgentResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.UPDATE_SESSION),
      payload: {
        session_id: sessionId,
        updates: data.updates || updates
      }
    });
    NotificationManager.success('Session updated', 'Success', 3000);
    return true;
  } catch (error) {
    dispatch({
      type: failReqActionType(actionConstants.UPDATE_SESSION)
    });
    NotificationManager.error(
      error.message || 'Failed to update session',
      'Error',
      3000
    );
    return false;
  }
};

export const deleteSession = sessionId => async dispatch => {
  dispatch({ type: startReqActionType(actionConstants.DELETE_SESSION) });
  const requestOptions = {
    method: 'DELETE',
    headers: apiHeader()
  };

  try {
    const response = await fetch(
      agentApiUrl(`/${encodeURIComponent(sessionId)}`),
      requestOptions
    );
    await parseAgentResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.DELETE_SESSION),
      payload: sessionId
    });
    NotificationManager.success('Session deleted', 'Success', 3000);
    return true;
  } catch (error) {
    dispatch({
      type: failReqActionType(actionConstants.DELETE_SESSION)
    });
    NotificationManager.error(
      error.message || 'Failed to delete session',
      'Error',
      3000
    );
    return false;
  }
};
